// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IVector3 {
  x: number;
  y: number;
  z: number;
}
